<template>
  <v-container fill-height>
    <div>
      <v-app-bar :elevation="2" :style="{ backgroundColor: colors.primary }">
        <v-app-bar-title :style="{ color: colors.secondary }">
          BAOBAB CHALLENGE 2024
        </v-app-bar-title>
        <div v-if="jury">
          <v-btn icon id="menu-activator">
            <v-avatar size="36px">
              <v-img alt="Jury" :src="getJuryImageUrl(jury?.image)"></v-img>
            </v-avatar>
          </v-btn>
          <v-menu activator="#menu-activator">
            <v-list>
              <v-list-item link>
                <v-list-item-title @click="goToHome">Accueil</v-list-item-title>
              </v-list-item>
              <v-list-item link>
                <v-list-item-title @click="goToEvaluate"
                  >Évaluation</v-list-item-title
                >
              </v-list-item>
              <v-list-item link>
                <v-list-item-title @click="logoutUser"
                  >Déconnexion</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div v-else>
          <v-btn
            @click="goToHome"
            icon="mdi-home"
            color="white"
            density="default"
          ></v-btn>
        </div>
      </v-app-bar>
      <!-- Add this overlay loader -->
      <div>
        <div class="d-flex align-center justify-center mb-4">
          <h1 class="mr-4 mb-0">RESULTATS</h1>
          <v-btn icon @click="fetchEvaluationResults" color="primary">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>

        <div v-if="isLoading" class="loader-overlay">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </div>
        <div v-else>
          <table>
            <thead>
              <tr>
                <th class="text-left">Critères</th>
                <th class="text-left">Explication des critères</th>
                <!-- <th>Max Score</th> -->
                <th style="min-width: 100px; text-align:center;" v-for="candidate in candidatesList" :key="candidate.id">
                  {{ candidate.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(criteria, index) in criterias.slice(0, 3)"
                :key="index"
              >
                <td class="text-left">{{ criteria.criteria }}</td>
                <td
                  class="text-left"
                  v-html="criteria.explanation.replace('\n', '<br>')"
                ></td>
                <!-- <td>{{ criteria.max_score }}</td> -->
                <td v-for="candidate in candidatesList" :key="candidate.id">
                  {{
                    evaluations[criteria.id] &&
                    evaluations[criteria.id][candidate.id]
                      ? evaluations[criteria.id][candidate.id]
                      : 0
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-left" colspan="2"><strong>TOTAL</strong></td>
                <!-- <td><strong>{{ getTotalMaxScoreForRows(1, 3) }}</strong></td> -->
                <td v-for="candidate in candidatesList" :key="candidate.id">
                  <strong>{{
                    getTotalScoreForCandidateByRows(candidate.id, 1, 3)
                  }}</strong>
                </td>
              </tr>
              <tr
                v-for="(criteria, index) in criterias.slice(3, 5)"
                :key="index"
              >
                <td class="text-left">{{ criteria.criteria }}</td>
                <td
                  class="text-left"
                  v-html="criteria.explanation.replace('\n', '<br>')"
                ></td>
                <!-- <td>{{ criteria.max_score }}</td> -->
                <td v-for="candidate in candidatesList" :key="candidate.id">
                  {{
                    evaluations[criteria.id] &&
                    evaluations[criteria.id][candidate.id]
                      ? evaluations[criteria.id][candidate.id]
                      : 0
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-left" colspan="2"><strong>TOTAL</strong></td>
                <!-- <td><strong>{{ getTotalMaxScoreForRows(4, 5) }}</strong></td> -->
                <td v-for="candidate in candidatesList" :key="candidate.id">
                  <strong>{{
                    getTotalScoreForCandidateByRows(candidate.id, 4, 5)
                  }}</strong>
                </td>
              </tr>
              <tr v-for="(criteria, index) in criterias.slice(5)" :key="index">
                <td class="text-left">{{ criteria.criteria }}</td>
                <td
                  class="text-left"
                  v-html="criteria.explanation.replace('\n', '<br>')"
                ></td>
                <!-- <td>{{ criteria.max_score }}</td> -->
                <td v-for="candidate in candidatesList" :key="candidate.id">
                  {{
                    evaluations[criteria.id] &&
                    evaluations[criteria.id][candidate.id]
                      ? evaluations[criteria.id][candidate.id]
                      : 0
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-left" colspan="2">
                  <strong>GRAND TOTAL</strong>
                </td>
                <!-- <td><strong>{{ totalMaxScore }}</strong></td> -->
                <td v-for="candidate in candidatesList" :key="candidate.id">
                  <strong>{{ getTotalScoreForCandidate(candidate.id) }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="winners?.length > 0" class="mt-3 center-data">
            <v-row justify="center">
              <v-col
                v-for="winner in winners"
                :key="winner.name"
                cols="12"
                sm="12"
                md="3"
              >
                <!-- Winners Section -->
                <v-card
                  v-if="winner.total_score!=0"
                  :key="winner.name"
                  class="pa-4 winner-card mb-4"
                  :style="{
                    margin: 'auto',
                    border: '1px solid #e5e5e5',
                    borderRadius: '10px',
                  }"
                  elevation="2"
                >
                  <v-card-title
                    class="text-center"
                    style="font-size: 20px; font-weight: bold"
                  >
                    <v-icon color="yellow darken-3" class="mr-2"
                      >mdi-trophy</v-icon
                    >
                    Gagnant:
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-row align="center" justify="center" class="winner-row">
                    <v-col class="mt-5">
                      <v-img
                        :src="getCandidateImageUrl(winner.image)"
                        alt="Candidate"
                        min-width="200"
                      ></v-img>
                    </v-col>
                    <v-col>
                      <div style="font-weight: 600">{{ winner.name }}</div>
                      <div style="font-size: 14px; color: #777">
                        Score: {{ winner.total_score }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- Other Candidates Section -->
            <div v-if="otherCandidates?.length > 0" class="other-winners mt-6">
              <h2 class="text-center mb-4">Autres classements</h2>
              <v-row justify="center">
                <v-col
                  v-for="candidate in otherCandidates"
                  :key="candidate.name"
                  cols="12"
                  sm="4"
                  md="3"
                >
                  <v-card class="pa-4">
                    <v-card-title class="text-center">
                      <!-- {{ getRankingText(candidate.rank) }} -->
                    </v-card-title>
                    <v-img
                      :src="getCandidateImageUrl(candidate.image)"
                      :alt="candidate.name"
                      class="mb-3"
                      max-height="100"
                    ></v-img>
                    <v-card-text class="text-center">
                      <div style="font-weight: 600">{{ candidate.name }}</div>
                      <div style="font-size: 14px; color: #777">
                        Score: {{ candidate.total_score }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
      <v-footer border app class="d-flex justify-center align-center p-4">
        Développé par :
        <a
          href="https://thewebsquare.com"
          target="_blank"
          :style="{ color: colors.primary }"
          >The Web Square</a
        >
      </v-footer>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import colors from "../styles/colors";
import axios from "axios";
import api from "../api";

export default {
  name: "ResultsScreen",
  data() {
    return {
      results: [],
      winners: [],
      otherCandidates: [],
      colors,
      isLoading: false,
      criterias: [], // Array to store criteria data
      evaluations: {}, // Object to store evaluations by criteria and candidate_id
      candidatesList: [], // List to store candidates from the API
    };
  },
  computed: {
    ...mapState([
      "jury",
      "candidates",
      "selectedCandidate",
      "criteriasByCategory",
    ]),
    totalMaxScore() {
      return this.criterias.reduce(
        (sum, criteria) => sum + criteria.max_score,
        0
      );
    },
    filteredWinners() {
      return this.winners.filter((winner) => winner.total_score > 0);
    },
  },
  methods: {
    ...mapActions([
      "updateJury",
      "updateCandidates",
      "updateCriteriasByCategory",
      "logout",
      "updateSelectedCandidate",
    ]),

    logoutUser() {
      this.logout();
      this.$nextTick(() => {
        this.$router.push({ name: "JurySelection" });
      });
    },

    getJuryImageUrl(filename) {
      return api.getJuryImageUrl(filename); // Generate the full image URL
    },

    getCandidateImageUrl(filename) {
      return api.getCandidateImageUrl(filename); // Generate the full image URL
    },

    getRankingText(rank) {
      return rank ? `Classement: ${rank}` : "Classement inconnu";
    },

    async fetchEvaluationResults() {
      this.isLoading = true;
      try {
        // Fetch criterias and evaluations
        const response = await axios.get(api.getGeneralResults);
        this.criterias = response.data.criterias;
        this.evaluations = response.data.evaluations;

        // Fetch candidates
        const candidatesResponse = await axios.get(api.getCandidates);
        this.candidatesList = candidatesResponse.data;

        // Fetch winners (now all ranked candidates)
        const allWinners = await axios.get(api.getWinner);
        this.winners = allWinners.data.winners;
        this.otherCandidates = allWinners.data.other_candidates;
      } catch (error) {
        console.error(
          "Error fetching evaluation results or candidates:",
          error
        );
      } finally {
        this.isLoading = false;
      }
    },

    getTotalScoreForCandidate(candidateId) {
      return this.criterias.reduce((sum, criteria) => {
        const score =
          this.evaluations[criteria.id] &&
          this.evaluations[criteria.id][candidateId]
            ? this.evaluations[criteria.id][candidateId]
            : 0;
        return sum + +score;
      }, 0);
    },

    getTotalScoreForCandidateByRows(candidateId, startRow, endRow) {
      return this.criterias
        .slice(startRow - 1, endRow)
        .reduce((sum, criteria) => {
          const score =
            this.evaluations[criteria.id] &&
            this.evaluations[criteria.id][candidateId]
              ? this.evaluations[criteria.id][candidateId]
              : 0;
          return sum + +score;
        }, 0);
    },

    getTotalMaxScoreForRows(startRow, endRow) {
      return this.criterias
        .slice(startRow - 1, endRow)
        .reduce((sum, criteria) => sum + +criteria.max_score, 0);
    },

    goToEvaluate() {
      this.$router.push({ name: "EvaluationScreen" });
    },

    goToHome() {
      this.$router.push({ name: "WelcomeScreen" });
    },
  },
  mounted() {
    this.fetchEvaluationResults();
  },
  // Your script logic goes here
};
</script>

<style>
/* Add your table styling here */
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
  text-align: left;
}

.winner-card {
  background-color: #f8f9fa; /* Light background */
  border-radius: 10px;
}

.winner-row {
  margin: 10px 0;
}

.v-card-title {
  color: #333;
  font-weight: bold;
}

.v-card-subtitle {
  padding: 10px;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
}

.center-data {
  margin: 0 auto;
  align-content: center;
  justify-content: center;
}
</style>